import ApplicationController from '../application_controller.js'
import { isBlank, parseString, formatNumber } from '../../commons.js'

export default class InvoiceRowController extends ApplicationController {

  static targets = ["svalue", "duration", "hourlyRate", "amount", "destroyFlag"]

  connect() {
    this.invoice_controller = this.getControllerByIdentifier('invoices--invoice')
  }

  disconnect() {
  }

  recomputeTaskAmount(e) {
    var duration = parseString(this.durationTarget.value)
    var rate = parseString(this.hourlyRateTarget.value)
    this.amountTarget.value = formatNumber(duration / 60 * rate)
    this.invoice_controller.preview()
  }

  forceSpecialRowAmount(e) {
    this.svalueTarget.value = 0
    this.previewInvoice(e)
  }

  previewInvoice(e) {
    this.invoice_controller.preview()
  }

  deleteRow(e) {
    e.preventDefault()
    this.destroyFlagTarget.value = 1
    this.element.closest('tr').style.display = "none"
    this.invoice_controller.preview()
  }

  userChanged(e) {
    let hourly_rate = e.target.options[e.target.selectedIndex].dataset.hourlyRate
    this.hourlyRateTarget.value = hourly_rate
    this.recomputeTaskAmount(e)
  }

}